import { Currency } from '@/core/currency/interfaces';

const CVE: Currency = {
    name: 'Cabo Verdean Escudo',
    demonym: 'Cabo Verdean',
    majorSingle: 'Escudo',
    majorPlural: 'Escudo',
    codeNumeric: '132',
    symbol: 'CV$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 0,
    numToBasic: 100,
    code: 'CVE',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CVE;
